module.exports = {
  Promise: typeof Promise !== 'undefined' ? Promise : null,
};
